module.exports = __webpack_public_path__ + "img/lumio-banner-1.654d55fb.png";